export default "__VITE_ASSET__BnVLHrNj__"